import React, { memo } from 'react';
import { ElectricVehicle, YamtIcon } from '@yme/assets/icons';
import { Image } from '@yme/atoms/image';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/common/hooks';
import { ProductLabel } from '@yme/molecules/product-label';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { CardProductPriceBlock } from '../card-product';
import { getDriverLicenseIcon } from '../filter-compare-card/helpers';
import { LinkStyled, YAMTIconStyled } from '../filter-compare-card/styled';
import { ContainerIconsStyled, ImageWrapperStyled, TitleStyled } from './styled';
function SearchProductCardComponent({ url, image, title, driverLicense, price, discountedValue, extraInformationTooltipText, isLabelFromVisible, isRightToLeft, isElectricVehicle, isYAMTIconShowed, isNewLabelShowed, }) {
    const { isMobileView } = useWindowSize();
    return (React.createElement(LinkStyled, { to: url },
        React.createElement(ImageWrapperStyled, { bg: colorCoreWhite1000, flexDirection: "column", justifyContent: "center", alignItems: "center" },
            React.createElement(ContainerIconsStyled, { isRightToLeft: isRightToLeft },
                driverLicense?.[0] && (React.createElement(SVGIcon, { type: getDriverLicenseIcon(driverLicense[0]), size: ICON_SIZE.sm })),
                isYAMTIconShowed && React.createElement(YAMTIconStyled, { type: YamtIcon }),
                isElectricVehicle && (React.createElement(SVGIcon, { type: ElectricVehicle, size: ICON_SIZE.sm }))),
            React.createElement(Image, { src: image, alt: title })),
        React.createElement(TitleStyled, { weight: 500 }, title),
        price && (React.createElement(CardProductPriceBlock, { isLabelFromVisible: isLabelFromVisible, isRightToLeft: isRightToLeft, price: price, discount: discountedValue, extraInformationTooltipText: extraInformationTooltipText })),
        React.createElement(ProductLabel, { isNew: isNewLabelShowed, isRightToLeft: isRightToLeft, isMobileView: isMobileView })));
}
export const SearchProductCard = memo(SearchProductCardComponent);
